import { Grid } from '@material-ui/core';
import React from 'react';
import { TaskListFilter } from '../../../state/task';
import { FilterContainer } from '../../components';
import { IFilterContainerConfigProps } from '../../components/FilterContainer';
import SearchFieldWithIcon from '../../components/SearchFieldWithIcon';

const TaskFilter: React.FC<IFilterContainerConfigProps<TaskListFilter>> = (props) => {
  return (
    <FilterContainer
      {...props}
      render={(filterProps) => {
        const { localFilter, handleChangeFilter } = filterProps;
        return (
          <Grid container spacing={1} alignItems={'center'}>
            <Grid item xs={12} md={4}>
              <SearchFieldWithIcon
                fullWidth={true}
                label="Task Number"
                filterKey={'TaskNumber.startsWith'}
                filters={localFilter}
                onChange={handleChangeFilter}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <SearchFieldWithIcon
                fullWidth={true}
                label="Requester"
                filterKey={'Requester.FullNameWithUserName.contains'}
                filters={localFilter}
                onChange={handleChangeFilter}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <SearchFieldWithIcon
                fullWidth={true}
                label="Subject"
                filterKey={'Subject.contains'}
                filters={localFilter}
                onChange={handleChangeFilter}
              />
            </Grid>
          </Grid>
        );
      }}
    />
  );
};

export default TaskFilter;
